export const tokens = {
  primary: {
    50: '#E6F7F8',
    100: '#CDEFF2',
    200: '#A3E0E7',
    300: '#7AD0DB',
    400: '#51C1D0',
    500: '#0E8D9D',
    600: '#0B7280',
    700: '#085963',
    800: '#053E45',
    900: '#02292D',
  },
  secondary: {
    500: '#003B5C',
  },
  accent: {
    50: '#FFF4E6',
    100: '#FFE2BD',
    200: '#FFC98E',
    300: '#FFB45F',
    400: '#FFA447',
    500: '#FF9F43',
    600: '#E88820',
  },
  neutrals: {
    0: '#FFFFFF',
    50: '#F5F7F8',
    100: '#E8ECEF',
    200: '#D1D5D9',
    300: '#B1B5B9',
    400: '#5F6368',
    500: '#202124',
  },
  semantic: {
    success: '#4CAF50',
    success50: '#E8F5E9',
    success100: '#C8E6C9',
    error: '#E53935',
    warning: '#FFC107',
    warning50: '#FFF8E1',
    warning100: '#FFECB3',
    warningText: '#C2741A',
    warningBorder: '#F4C77E',
    warningSurface: '#FFF8EE',
    warningFieldBorder: '#F0B860',
    warningFieldSurface: '#FFFCF6',
    info: '#0E8D9D',
    info50: '#E6F7F8',
    info100: '#CDEFF2',
  },
  shadows: {
    card: '0 4px 16px rgba(8,89,99,0.06)',
  },
} as const;
